import { memo, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import {
  notifyError,
  notifySuccess,
} from "../../../../components/ToastContainer/Toast/Toast";
import { deleteDish } from "../../../../service/BuyerConfiguration/DishManagement/dishService";

type PropsDeleteDish = {
  selectedDeleteId: number | null;
  setOpenDeleteDialog: (open: boolean) => void;
  fetchDishes?: () => Promise<void>;
  setSelectedDeleteId: (id: number | null) => void;
  selectedRowsData: any;
};
const DeleteDish: React.FC<PropsDeleteDish> = memo(
  ({
    selectedDeleteId,
    setOpenDeleteDialog,
    fetchDishes,
    setSelectedDeleteId,
    selectedRowsData,
  }) => {
    const handleDelete = useCallback(
      async (id: number) => {
        try {
          const response = await deleteDish(id);
          if (response.statusCode === 200 || response.statusCode === 201) {
            notifySuccess(response.data.message || "Dish deleted successfully");
          }
        } catch (error) {
          notifyError(
            error?.response?.data?.message || "Something went wrong!"
          );
        } finally {
          setOpenDeleteDialog(false);
          fetchDishes?.();
          setSelectedDeleteId(null);
        }
      },
      [fetchDishes, setOpenDeleteDialog, setSelectedDeleteId]
    );

    const handleCancel = useCallback(() => {
      setOpenDeleteDialog(false);
      setSelectedDeleteId(null);
    }, [setOpenDeleteDialog, setSelectedDeleteId]);

    if (!selectedDeleteId) {
      return null;
    }
    return (
      <>
        <Box display="flex" flexDirection="column" gap={2} justifyContent="center" p={2}>
          <Typography> <strong>Name:</strong> {selectedRowsData?.name}</Typography>
          <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}><strong>Icon:</strong> <img src={selectedRowsData?.icon} alt="Icon" width={50} height={50} style={{ objectFit: "contain" }} /></Typography>
          <Typography><strong>Food Type:</strong> {selectedRowsData?.food_type}</Typography>
          <Typography><strong>Status:</strong> {selectedRowsData?.status ? "Active" : "Inactive"}</Typography>
          <Typography><strong>Sequence:</strong> {selectedRowsData?.sequence}</Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={2} alignItems="center" justifyContent="center" p={2}>
          <Typography>Are you sure you want to delete this dish?</Typography>
        </Box>
        <Box display="flex" gap={2} mt={2} justifyContent="flex-end">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleDelete(selectedDeleteId as number);
            }}
          >
            Delete
          </Button>
          <Button variant="outlined" color="primary" onClick={handleCancel}>
            Cancel
          </Button>
        </Box>
      </>
    );
  }
);

export default DeleteDish;
